import commonGetters from '@/store/ui/common/getters'
import { filter, toNumber } from 'lodash'

const getters = {
    ...commonGetters,
    getAllActiveExtraTaxo: (state) => () => {
        const taxoList = state.extraTaxo.list
        const activeTaxos = []
        for (const taxo in taxoList) {
            for (const individualTaxo of taxoList[taxo]) {
                if (individualTaxo.status === 'active') {
                    const activeTaxo = {
                        label: individualTaxo.label,
                        owner: individualTaxo.owner,
                        status: individualTaxo.status,
                        taxonomy: individualTaxo.taxonomy
                    }
                    activeTaxos.push(activeTaxo)
                }
            }
        }
        return activeTaxos
    },
    getActiveSharing: (_state, _getters, rootState ) => params => {
        const sharingType = params.sharingType
        const sharingList = rootState.data.settings.sharing[sharingType]
        let alreadyActiveSharing

        if (sharingType === 'taxonomies') {
            alreadyActiveSharing = filter(sharingList, sharing => sharing.wam_custom_taxonomy_sharing === 'active').map(filteredSharing =>
                toNumber(filteredSharing.id)
            )
        } else if (sharingType === 'audiences') {
            alreadyActiveSharing = filter(sharingList, sharing => sharing.audience_sharing === 'active').map(filteredSharing => toNumber(filteredSharing.id))
        }
        return alreadyActiveSharing
    }
}

export default getters
